import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Only allows users with is_admin === true (not sub-admins)
const SuperAdminRoute = ({ children }) => {
  const UsersProfile = useSelector((state) => state.UsersProfile);
  const isAdmin = UsersProfile?.personalDetails?.data?.is_admin === true;

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default SuperAdminRoute;
